<template>
  <div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>기본정보</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">사업장명</div>
        <span v-if="isPrint"> {{form.inputA_1}} </span>
        <vs-input v-else class="w-full flex-1" v-model="form.inputA_1" :readonly="true"></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">소속</div>
        <span v-if="isPrint"> {{form.inputA_3}} </span>
        <vs-input v-else class="w-full flex-1" v-model="form.inputA_3" :readonly="true" ></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">부서</div>
        <span v-if="isPrint"> {{form.inputA_2}} </span>
        <vs-input v-else class="w-full flex-1" v-model="form.inputA_2" :readonly="true"></vs-input>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성자</div>
        <span v-if="isPrint"> {{form.inputA_4}} </span>
        <vs-input v-else class="w-full flex-1" v-model="form.inputA_4" :readonly="true"></vs-input>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작성일</div>
        <span v-if="isPrint"> {{form.inputA_5}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputA_5" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>아차사고 사례카드</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-6 flex items-center">
        <div class="label-text mr-4">사례명</div>
        <span v-if="isPrint"> {{form.inputB_1}} </span>
        <vs-input v-else class="w-full flex-1" v-model="form.inputB_1" :readonly="board.readonly"></vs-input>
      </div>
      <div class="col-span-6 flex items-center">
        <div class="label-text mr-4">공종</div>
        <span v-if="isPrint"> {{form.inputB_2}} </span>
        <work-type-a-selector v-else class="w-full flex-1" v-model="form.inputB_2" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-6 flex items-center">
        <div class="label-text mr-4">발생일시</div>
        <span v-if="isPrint"> {{form.inputB_3}} </span>
        <date-selector v-else class="w-full flex-1" v-model="form.inputB_3" :readonly="board.readonly"/>
      </div>
      <div class="col-span-6 flex items-center">
        <div class="label-text mr-4">발생장소</div>
        <span v-if="isPrint"> {{form.inputB_4}} </span>
        <vs-input v-else class="w-full flex-1" v-model="form.inputB_4" :readonly="board.readonly"></vs-input>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-6 flex items-center">
        <div class="label-text mr-4">제안자</div>
        <span v-if="isPrint"> {{form.inputB_5}} </span>
        <vs-input v-else class="w-full flex-1" v-model="form.inputB_5" :readonly="board.readonly"></vs-input>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">발생개요</div>
        <span v-if="isPrint"> {{form.inputB_6}} </span>
        <vs-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_6" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">발생원인</div>
        <span v-if="isPrint"> {{form.inputB_7}} </span>
        <vs-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_7" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-6 flex items-center">
        <div class="label-text mr-4">재해형태</div>
        <span v-if="isPrint"> {{form.inputB_8 == 1 ? '선택' : ''}} </span>
        <disaster-class-selector
          v-else
          class="flex-1 w-full"
          v-model="form.inputB_8"
          :readonly="board.readonly"
        ></disaster-class-selector>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">예상피해</div>
        <span v-if="isPrint"> {{form.inputB_9}} </span>
        <vs-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_9" :readonly="board.readonly"/>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">방지대책</div>
        <span v-if="isPrint"> {{form.inputB_10}} </span>
        <vs-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_10" :readonly="board.readonly"/>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>관련사진</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12 h-upload" >
      <div class="col-span-6 upload-content">
        <div class="upload-content__title">
          개선 전 사진
        </div>
        <div class="upload-content__file">
          <file-uploader type="only-image" v-if="!isPrint" v-model="form.img1" :readonly="board.readonly"></file-uploader>
          <img class="w-full h-full" v-else :src="form.img1.thumb"/>
        </div>
      </div>
      <div class="col-span-6 upload-content">
        <div class="upload-content__title">
          개선 후 사진
        </div>
        <div class="upload-content__file">
          <file-uploader type="only-image" v-if="!isPrint" v-model="form.img2" :readonly="board.readonly"></file-uploader>
          <img class="w-full h-full" v-else :src="form.img2.thumb"/>
        </div>
      </div>
    </div>
    <vs-row class="my-4">
      <vs-col
        ><h5><i class="dot"></i>위험성평가(평가 후 등록부에 기록)</h5></vs-col
      >
    </vs-row>
    <div class="grid grid-cols-12">
      <div class="col-span-6 upload-content">
        <div class="upload-content__title">
          개선 전 위험성 (5x4)
        </div>
        <div class="grid grid-cols-12" style="padding-top: 0rem;">
          <div class="col-span-4 sub-title">
            가능성(빈도)
          </div>
          <div class="col-span-4 sub-title">
            중대성(강도)
          </div>
          <div class="col-span-4 sub-title">
            위험성
          </div>
        </div>
        <div class="grid grid-cols-12" style="padding-top: 0rem;">
          <div class="col-span-4 sub-select">
            <span v-if="isPrint"> {{frequency}} </span>
            <vs-select
            v-else
            class="flex-1 w-full"
            v-model="frequency"
            autocomplete
            :readonly="board.readonly"
              >
              <vs-select-item :key="n" :value="n" :text="n" v-for="n in 5"/>
            </vs-select>
          </div>
          <div class="col-span-4 sub-select">
            <span v-if="isPrint"> {{strength}} </span>
            <vs-select
            v-else
            class="flex-1 w-full"
            v-model="strength"
            autocomplete
            :readonly="board.readonly"
              >
              <vs-select-item :key="n" :value="n" :text="n" v-for="n in 4"/>
            </vs-select>
          </div>
          <div class="col-span-4 sub-select">
            <span v-if="isPrint"> {{rank}} </span>
            <vs-input
              v-else
              class="w-full flex-1 text-select-item"
              :class="rank"
              v-model="rank"
              :readonly="true"></vs-input>
          </div>
        </div>
      </div>
      <div class="col-span-6 upload-content">
        <div class="upload-content__title">
          개선 후 위험성 (5x4)
        </div>
        <div class="grid grid-cols-12" style="padding-top: 0rem;">
          <div class="col-span-4 sub-title">
            가능성(빈도)
          </div>
          <div class="col-span-4 sub-title">
            중대성(강도)
          </div>
          <div class="col-span-4 sub-title">
            위험성
          </div>
        </div>
        <div class="grid grid-cols-12" style="padding-top: 0rem;">
          <div class="col-span-4 sub-select">
            <span v-if="isPrint"> {{frequency2}} </span>
            <vs-select
            v-else
            class="flex-1 w-full"
            v-model="frequency2"
            autocomplete
            :readonly="board.readonly"
              >
              <vs-select-item :key="n" :value="n" :text="n" v-for="n in 5"/>
            </vs-select>
          </div>
          <div class="col-span-4 sub-select">
            <span v-if="isPrint"> {{strength2}} </span>
            <vs-select
            v-else
            class="flex-1 w-full"
            v-model="strength2"
            autocomplete
            :readonly="board.readonly"
              >
              <vs-select-item :key="n" :value="n" :text="n" v-for="n in 4"/>
            </vs-select>
          </div>
          <div class="col-span-4 sub-select">
            <span v-if="isPrint"> {{rank2}} </span>
            <vs-input
              v-else
              class="w-full flex-1 text-select-item"
              :class="rank2"
              v-model="rank2"
              :readonly="true"></vs-input>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-6 flex items-center">
        <div class="label-text mr-4">제안등급</div>
        <span v-if="isPrint"> {{checkBox == 1 ? '1급(80-100' : checkBox == 2 ? '2급(65-79)' : '3급(64이하)'}} </span>
        <template v-else>
          <vs-checkbox
          class="label-text mr-2"
          :vs-value="1"
          v-model="checkBox"
          @change="onCheck($event)"
          :readonly="board.readonly"> 1급(80-100) </vs-checkbox>
          <vs-checkbox
          class="label-text mr-2"
          :vs-value="2"
          v-model="checkBox"
          @change="onCheck($event)"
          :readonly="board.readonly"> 2급(65-79) </vs-checkbox>
          <vs-checkbox
          class="label-text mr-2"
          :vs-value="3"
          v-model="checkBox"
          @change="onCheck($event)"
          :readonly="board.readonly"> 3급(64이하) </vs-checkbox>
        </template>
      </div>
      <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">적용범위</div>
          <span v-if="isPrint"> {{form.inputC_2}} </span>
          <vs-input v-else class="w-full flex-1" v-model="form.inputC_2" :readonly="board.readonly"></vs-input>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from '@/components/selector/DateSelector'
import FileUploader from "@/components/FileUploader.vue";
import WorkTypeASelector from "@/components/selector/WorkTypeASelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
export default {
  name: "Write",
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data () {
    return {
      frequency: 1,
      strength: 1,
      rank: 'F',
      frequency2: 1,
      strength2: 1,
      rank2: 'F',
      checkBox: [],
      form: {
        inputA_1:'',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputB_1:'',
        inputB_2:'',
        inputB_3:'',
        inputB_4:'',
        inputB_5:'',
        inputB_6:'',
        inputB_7:'',
        inputB_8:'',
        inputB_9:'',
        inputB_10:'',
        inputC_1:'',
        inputC_2: '',
        frequency: 1,
        strength: 1,
        frequency2: 1,
        strength2: 1,
        img1: {},
        img2: {},
      }
    }
  },
  watch: {
    frequency() {
      this.form.frequency = this.frequency
      if(this.strength) {
        this.rank = this.renderRank(this.strength * this.frequency)
      }
    },
    strength() {
      this.form.strength = this.strength
      if(this.frequency) {
        this.rank = this.renderRank(this.strength * this.frequency)
      }
    },
    frequency2() {
      this.form.frequency2 = this.frequency2
      if(this.strength2) {
        this.rank2 = this.renderRank(this.strength2 * this.frequency2)
      }
    },
    strength2() {
      this.form.strength2 = this.strength2
      if(this.frequency2) {
        this.rank2 = this.renderRank(this.strength2 * this.frequency2)
      }
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.writer.com_name
        this.form.inputA_4 = this.value && this.value.inputA_4 ? this.value.inputA_4 : this.board.writer.name
        this.form.inputA_3 = this.value && this.value.inputA_3 ? this.value.inputA_3 : this.board.writer.department
      }
    },
    value(value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }

      if (typeof this.form.img1 != 'object') {
          this.form.img1 = {};
      }
      if (typeof this.form.img2 != 'object') {
          this.form.img2 = {};
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1
        value.summary = [value.inputA_5]
        this.$emit('input', value);
      }
    }
  },
  methods: {
    renderRank(value) {
     if(value <= 3 && value >= 1)
      return 'F'
      if(value <= 6 && value >= 4)
      return 'E'
      if(value === 8)
      return 'D'
      if(value <= 12 && value >= 9)
      return 'C'
      if(value === 15)
      return 'B'
      if(value <= 20 && value >= 16)
      return 'A'
    },
    onCheck(event) {
      this.checkBox = [event[event.length - 1]]
    }
  },
  components: {
    DateSelector,
    FileUploader,
    DisasterClassSelector,
    WorkTypeASelector
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
width: 114px;
font-weight: 500;
font-size: 14px;
margin-right: 16px;
}
.mt-component-form {
  margin-top: 20px;
}
.sub-title {
  text-align: center;
  border-right: $border;
  border-bottom: $border;
  padding: 1rem;
}
.sub-select {
  padding: 0.5rem;
  border-right: $border;
}
.grid {
  padding-top: 1rem;
}
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.h-exten{
  height: inherit;
}
.text-select-item {
  color: #e42728;
  &.E { color: #ff8510 }
  &.F { color: #28c76f }
}
</style>
